import { render, staticRenderFns } from "./DetailReceipt.vue?vue&type=template&id=c5611266&scoped=true&"
import script from "./DetailReceipt.vue?vue&type=script&lang=ts&"
export * from "./DetailReceipt.vue?vue&type=script&lang=ts&"
import style0 from "./DetailReceipt.vue?vue&type=style&index=0&id=c5611266&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5611266",
  null
  
)

export default component.exports